// TooltipWrapper.js
import React from 'react';
import Tooltip from '@mui/material/Tooltip';

const TooltipWrapper = ({ title, children }) => (
  <Tooltip
    title={title}
    arrow
    componentsProps={{
      tooltip: {
        sx: {
          fontSize: '0.95rem',
          padding: '8px 12px',
          borderRadius: '6px',
          maxWidth: '240px',
          backgroundColor: 'rgba(60,60,60,0.95)',
          color: '#fff',
        },
      },
    }}
  >
    {children}
  </Tooltip>
);

export default TooltipWrapper;
